var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconKebabGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3050_9393",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5H0V20.5H20V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3050_9393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16602 10.4974C9.16602 10.7185 9.25381 10.9304 9.41009 11.0867C9.56637 11.243 9.77833 11.3308 9.99934 11.3308C10.2204 11.3308 10.4323 11.243 10.5886 11.0867C10.7449 10.9304 10.8327 10.7185 10.8327 10.4974C10.8327 10.2764 10.7449 10.0645 10.5886 9.90814C10.4323 9.75186 10.2204 9.66406 9.99934 9.66406C9.77833 9.66406 9.56637 9.75186 9.41009 9.90814C9.25381 10.0645 9.16602 10.2764 9.16602 10.4974Z",
    fill: "#CCCCCC",
    stroke: "#CCCCCC",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16602 16.3333C9.16602 16.5543 9.25381 16.7663 9.41009 16.9226C9.56637 17.0789 9.77833 17.1667 9.99934 17.1667C10.2204 17.1667 10.4323 17.0789 10.5886 16.9226C10.7449 16.7663 10.8327 16.5543 10.8327 16.3333C10.8327 16.1123 10.7449 15.9004 10.5886 15.7441C10.4323 15.5878 10.2204 15.5 9.99934 15.5C9.77833 15.5 9.56637 15.5878 9.41009 15.7441C9.25381 15.9004 9.16602 16.1123 9.16602 16.3333Z",
    fill: "#CCCCCC",
    stroke: "#CCCCCC",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16602 4.66536C9.16602 4.88637 9.25381 5.09833 9.41009 5.25461C9.56637 5.4109 9.77833 5.49869 9.99934 5.49869C10.2204 5.49869 10.4323 5.4109 10.5886 5.25461C10.7449 5.09833 10.8327 4.88637 10.8327 4.66536C10.8327 4.44435 10.7449 4.23238 10.5886 4.0761C10.4323 3.91982 10.2204 3.83203 9.99934 3.83203C9.77833 3.83203 9.56637 3.91982 9.41009 4.0761C9.25381 4.23238 9.16602 4.44435 9.16602 4.66536Z",
    fill: "#CCCCCC",
    stroke: "#CCCCCC",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKebabGrey);
export default __webpack_public_path__ + "static/media/Icon_Kebab_Grey.7aa8c535a1ed54967ab72782eff670df.svg";
export { ForwardRef as ReactComponent };